import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";

const OrderStepButtons = props => {
  return (
    <div className="web-order-buttons">
          {props.currentStep > 0 &&
            <Button color="secondary"
              onClick={props.onPrevious}
              disabled={props.isLoading}
            >Previous</Button>}
          { /* Empty div to keep next button on far right when hiding previous */}
          <div />
          <Button
            onClick={props.onNext}
            disabled={props.isLoading || props.nextIsDisabled}
          >{props.nextTitle ?? "Next"}</Button>
        </div>
  );
};

OrderStepButtons.propTypes = {
  currentStep: PropTypes.number,  // Current step index used to hide/show buttons
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  isLoading: PropTypes.bool,   // Disables buttons while loading
  nextTitle: PropTypes.string,  // Optional, override next button title
  nextIsDisabled: PropTypes.bool,
};

export default OrderStepButtons;